module.exports = __webpack_public_path__ + "img/lungs.ce26296f.svg";